<template>
    <b-modal
        v-model="saveTemplateModal.isOpen"
        modal-class="vue-need-bootstrap"
        header-class="px-3"
        title-class="font-weight-bold"
        body-class="pb-1"
        ok-only
        no-close-on-backdrop
        no-close-on-esc
        scrollable
        centered
        :title="getTitle"
        size="lg"
        hide-footer
    >
        <div class="content px-1">
            <p class="text">
                Your template
                <span class="font-weight-bold">{{ productTitle }}</span>
                has been saved.
            </p>
            <div class="d-flex align-items-center mt-2">
                <p class="text mb-0">
                    Template ID:
                    <span
                        v-tippy="{ content: 'Copied to clipboard!', trigger: 'click' }"
                        class="text-primary underline"
                        @click="copyToClipboard"
                        >{{ saveTemplateModal.productId }}</span
                    >
                </p>
                <div class="ml-4">
                    <button
                        v-tippy="{ content: 'Copied to clipboard!', trigger: 'click' }"
                        class="btn copy-btn gray-backgorund"
                        @click="copyToClipboard"
                    >
                        <font-awesome-icon :icon="['fas', 'copy']" style="color: #333333" />
                    </button>
                </div>
            </div>
            <p class="text mt-3">You can return to Templates to continue editing or connect it to a product.</p>
        </div>

        <div class="modal-footer">
            <b-button type="reset" variant="outline-primary" @click="onNavigateToHomeClick">Back to Templates</b-button>
            <b-button variant="primary" class="bottom-margin" @click="onNavigateToTemplatesClick"
                >Connect to Product</b-button
            >
        </div>
    </b-modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { BModal } from 'bootstrap-vue';
const props = defineProps<{
    saveTemplateModal: {
        isOpen: boolean;
        title: string;
        productTitle: string;
        productId: string;
    };
}>();
const emit = defineEmits(['navigateToHome', 'navigateToTemplates']);
const getTitle = computed((): string => {
    return props.saveTemplateModal?.title;
});
async function copyToClipboard() {
    const msgToCopy = props.saveTemplateModal.productId;
    if (!msgToCopy) {
        return;
    }
    await navigator.clipboard.writeText(msgToCopy);
}
const productTitle = computed((): string => {
    const fullTitle = props.saveTemplateModal?.productTitle || '';
    if (fullTitle.length <= 58) {
        return fullTitle;
    }

    // Find the last space before the 58th character
    const lastSpaceIndex = fullTitle.lastIndexOf(' ', 57);

    // If no space is found, just truncate at 58 (single long word)
    const truncateIndex = lastSpaceIndex === -1 ? 58 : lastSpaceIndex;

    return fullTitle.slice(0, truncateIndex) + '...';
});

function onNavigateToHomeClick() {
    emit('navigateToHome');
}
function onNavigateToTemplatesClick() {
    emit('navigateToTemplates', props.saveTemplateModal.productId);
}
</script>

<style scoped lang="scss">
.text {
    font-size: 16px;
}
.underline {
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
}
.gray-backgorund {
    background-color: #f0f1f2 !important;
}
.bottom-margin {
    margin-bottom: 0.25rem !important;
}
</style>
